import { render, staticRenderFns } from "./orgPositionSelect.vue?vue&type=template&id=23665a16&scoped=true"
import script from "./orgPositionSelect.vue?vue&type=script&lang=js"
export * from "./orgPositionSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23665a16",
  null
  
)

export default component.exports